import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const AdvertisersService = {
  // Get all advertisers with pagination and filtering
  advertisersList: async ({
    advertiserName,
    advertiserEmail,
    page = 1,
    pageSize = 12,
  } = {}) => {
    const filterList = [];
    if (advertiserName && advertiserName.trim())
      filterList.push(`AdvertiserName=${encodeURIComponent(advertiserName.trim())}`);
    if (advertiserEmail && advertiserEmail.trim())
      filterList.push(`AdvertiserEmail=${encodeURIComponent(advertiserEmail.trim())}`);
    if (page) filterList.push(`page=${page}`);
    if (pageSize) filterList.push(`pageSize=${pageSize}`);
    
    const filterString =
      filterList.length > 0 ? `?${filterList.join("&")}` : "";
    const response = await apiService.get(`/advertisers${filterString}`);
    return response.data;
  },

  // Create a new advertiser
  create: async (data) => {
    try {
      const response = await apiService.post("/advertisers", data);
      return response.data;
    } catch (error) {
      console.error("Error creating advertiser:", error);
      throw error;
    }
  },

  // Get advertiser by id
  getAdvertiserById: async (id) => {
    try {
      const response = await apiService.get(`/advertisers/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching advertiser:", error);
      throw error;
    }
  },

  // Update an advertiser
  update: async (id, data) => {
    try {
      const response = await apiService.put(`/advertisers/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating advertiser:", error);
      throw error;
    }
  },

  // Delete an advertiser
  delete: async (id) => {
    try {
      const response = await apiService.delete(`/advertisers/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting advertiser:", error);
      throw error;
    }
  },

  // Get ad summary statistics
  getAdSummary: async (adId) => {
    try {
      const response = await apiService.get(`/itouch/ad-stats/ad-summary/${adId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching ad summary:", error);
      throw error;
    }
  },

  // Get advertiser statistics by media type
  getAdvertiserStatsByMediaType: async ({
    startDate,
    endDate,
    advertiserId,
    advertiserName,
  } = {}) => {
    try {
      const filterList = [];
      if (startDate)
        filterList.push(`startDate=${encodeURIComponent(startDate)}`);
      if (endDate)
        filterList.push(`endDate=${encodeURIComponent(endDate)}`);
      if (advertiserId)
        filterList.push(`advertiserId=${advertiserId}`);
      if (advertiserName)
        filterList.push(`advertiserName=${encodeURIComponent(advertiserName)}`);

      const filterString =
        filterList.length > 0 ? `?${filterList.join("&")}` : "";
      const response = await apiService.get(
        `/itouch/advertiser-stats/advertiser/media-type${filterString}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching advertiser stats by media type:", error);
      throw error;
    }
  },

  // Get advertiser statistics by screen type
  getAdvertiserStatsByScreenType: async ({
    startDate,
    endDate,
    advertiserId,
    advertiserName,
  } = {}) => {
    try {
      const filterList = [];
      if (startDate)
        filterList.push(`startDate=${encodeURIComponent(startDate)}`);
      if (endDate)
        filterList.push(`endDate=${encodeURIComponent(endDate)}`);
      if (advertiserId)
        filterList.push(`advertiserId=${advertiserId}`);
      if (advertiserName)
        filterList.push(`advertiserName=${encodeURIComponent(advertiserName)}`);

      const filterString =
        filterList.length > 0 ? `?${filterList.join("&")}` : "";
      const response = await apiService.get(
        `/itouch/advertiser-stats/advertiser/screen-wise${filterString}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching advertiser stats by screen type:", error);
      throw error;
    }
  },
};

export default AdvertisersService;
